import { NavigateNavigation } from './NavigatePage.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { html, nothing } from 'lit';
import { VoicesNavigation } from './VoicesPage.js';
import callIcon from '../assets/call.svg';
import callEndIcon from '../assets/call_end.svg';
import languageIcon from '../assets/language.svg';
import ticketIcon from '../assets/ticket.svg';
import logo from '../assets/zwickroell_logo.svg';

// 🆕 2026-08-29 — the first four nav links are hidden on request.
//
// Hidden rather than removed: /analytics, /studio, /vault and / are still routed and still answer
// when typed, so nothing is lost and nothing has to be rebuilt if they come back. Flip this to
// true to restore all four at once. The logo still navigates to /, so dropping the Tickets link
// does not strand the root.
const SHOW_STUDIO_LINKS: boolean = false;

export const Header = () => html`
  <header class="bg-base-100 sticky top-0 z-40">
    <div class="container mx-auto flex items-center justify-between py-6 px-4">
      <div class="flex items-center gap-3">
        <button
          class="bg-transparent border-none p-0 m-0 cursor-pointer focus:outline-none"
          title="Go to homepage"
          @click=${() => goTo('/')}
        >
          <img src="${logo}" alt="ZwickRoell Logo" class="h-8 w-auto select-none" draggable="false" />
        </button>
      </div>
      <div class="flex items-center gap-6 ml-auto">
        <nav class="flex flex-wrap justify-end gap-x-4 gap-y-2 text-base-content">
          ${SHOW_STUDIO_LINKS
            ? html` <a
                  class="flex items-center gap-1 hover:text-primary font-medium"
                  href="/analytics"
                  title="Claude Powered Analytics"
                >
                  <svg
                    class="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M12 3l1.6 4.8L18 9.4l-4.4 1.6L12 16l-1.6-5L6 9.4l4.4-1.6L12 3z"></path>
                    <path d="M19 14l.7 2.1L22 17l-2.3.9L19 20l-.7-2.1L16 17l2.3-.9L19 14z"></path>
                  </svg>
                  <span>Claude Powered Analytics</span>
                </a>
                <a class="flex items-center gap-1 hover:text-primary font-medium" href="/studio" title="Skill Studio">
                  <svg
                    class="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                    <rect x="14" y="14" width="7" height="7"></rect>
                  </svg>
                  <span>Skill Studio</span>
                </a>
                <a class="flex items-center gap-1 hover:text-primary font-medium" href="/vault" title="Vault Studio">
                  <svg
                    class="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  </svg>
                  <span>Vault Studio</span>
                </a>
                <a class="flex items-center gap-1 hover:text-primary" href="/">
                  <img src="${ticketIcon}" alt="Tickets" class="h-5 w-5" />
                  <span>Tickets</span>
                </a>`
            : nothing}
          <a class="flex items-center gap-1 hover:text-primary" href="/local-tickets">
            <img src="${languageIcon}" alt="Local Tickets" class="h-5 w-5" />
            <span>Local Tickets</span>
          </a>
          <a class="flex items-center gap-1 hover:text-primary" href="/call">
            <img src="${callIcon}" alt="Call" class="h-5 w-5" />
            <span>Call</span>
          </a>
          <a class="flex items-center gap-1 hover:text-primary" href="/calls">
            <img src="${callEndIcon}" alt="Calls" class="h-5 w-5" />
            <span>Anrufe</span>
          </a>
          <a class="flex items-center gap-1 hover:text-primary" href="/test-lab">
            <svg
              class="h-5 w-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              aria-hidden="true"
            >
              <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" />
              <path
                d="m9 3-.5 2-2 1.2-2-.5-2 3.5L4 10.5v3l-1.5 1.3 2 3.5 2-.5 2 1.2.5 2h4l.5-2 2-1.2 2 .5 2-3.5-1.5-1.3v-3l1.5-1.3-2-3.5-2 .5-2-1.2-.5-2Z"
              />
            </svg>
            <span>Settings</span>
          </a>
          ${VoicesNavigation()} ${NavigateNavigation()}
          <a
            class="flex items-center gap-1 hover:text-primary"
            href="/business-logic"
            title="Gesprächsabläufe und Verifizierungsregeln"
            >Business Logic</a
          >
          <a
            class="flex items-center gap-1 hover:text-primary"
            href="/test-lab/feedback"
            title="Beobachtungen zu Test-Anrufen"
          >
            <img src="${ticketIcon}" alt="Feedback" class="h-5 w-5" />
            <span>Feedback</span>
          </a>
        </nav>
      </div>
    </div>
  </header>
`;
